import './App.css';
import { useState, useEffect } from 'react';
import BarLoader from "react-spinners/BarLoader";

const questions = ["1+2", "2-1", "4+6", "4+7", "5+3", "10-4", "3-1", "4+5"];
const answers = ['3', '1', '10', '11', '8', '6', '2', '9'];

function App() {
  const [fullname, setName] = useState('');
  const [email, setEmail] = useState('');
  const [answer, setAnswer] = useState('');
  const [currentAnswer, setCurrentAnswer] = useState(0);
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [qError, setQError] = useState(false)
  const [error, setError] = useState('');
  const [waiting, setWaiting] = useState(false);

  const setRandomQ = () => {
    let rand = -1;
    do{
      rand = Math.floor(Math.random() * (questions.length-1));
    }while(rand === currentAnswer);

    setCurrentAnswer(rand);
  }

  useEffect(() => {
    setRandomQ();
  }, []);

  const validateName = () => {
    let fnv = false;

    if(/^([^0-9]*)$/.test(fullname) && fullname.length >= 2)
      fnv = true;

    setNameError(!fnv);

    return fnv;
  }

  const validateEmail = () => {
    let emv = false;

    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) && email !== '')
      emv = true;

    setEmailError(!emv);
    
    return emv;
  }

  const validateQuestion = () => {
    console.log("index: " + currentAnswer);
    console.log(answers[currentAnswer]);
    console.log(answer);
    if(answer === answers[currentAnswer]){
      setAnswer('');
      return true;
    }else{
      setAnswer('');
      setQError(true);
      return false;
    }
  }

  const handleSubmit = async (e) => {
      e.preventDefault();

      if(!waiting){
          setError(false);
    
          let emv = validateEmail();
          let fnv = validateName();
          let qv = validateQuestion();
    
          if(emv && fnv && qv){
            setWaiting(true);
            setNameError(false);
            setEmailError(false);
            setQError(false);
            let url = "https://project992-backend.herokuapp.com/beta/signUp";
      
            const response = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({ fullname, email })
            });
      
            let status = response.status;
            let data = await response.json();
            setWaiting(false);
      
            if(status === 200){
              alert('Thank you for siging up, you will be notified when the beta version is released.');
              setEmail('');
              setName('');
            }else{
              console.log(JSON.stringify(data.error));
              setError(data.error);
            }
          }else{
            setRandomQ();
          }
      }
  }

  return (
    <div className="App">
      <div className="container">
        <h1>Project 992</h1>
        <h5>Sign up below for the beta release of Project 992.</h5>
        <form onSubmit={handleSubmit}>
        <div className="input-fields">
          <div className="input-box">
            <label>
                <span>Full name:</span><br/>
                <input type='text' value={fullname} onChange={(e) => setName(e.target.value)}/>
            </label>
          </div>
          {nameError ? (
            <p className="error">Please enter a valid name.</p>  
          ) :  <p className="error muted">Please enter a valid name.</p>  }
          <div className="input-box">
            <label>
                <span>Email:</span><br/>
                <input type='text' value={email} onChange={(e) => setEmail(e.target.value)}/>
            </label>
          </div>
          {emailError ? (
            <p className="error">Please enter a valid email address.</p>  
          ) : <p className="error muted">Please enter a valid email address.</p> }
          <div className="input-box-q input-box">
            <label>
                <span>{questions[currentAnswer] + "= "}</span><br/>
                <input type='text' value={answer} onChange={(e) => setAnswer(e.target.value)}/>
            </label>
          </div>
          {qError ? (
            <p className="error">Solve security question.</p>  
          ) : <p className="error muted">Solve security quesiton.</p> }
        </div>
        <div className="submit-box">
          {error !== '' ? (
            <p className="error">{error}</p>  
          ) : null}
          <br/>
          {waiting ? (
            <div className="spinner-container">
              <BarLoader color={"#1C1C21"} loading={waiting} width={90} height={2} />
            </div>
          ) : <input type='submit' value='Sign up'/>}
        </div>
        </form>
      </div>
    </div>
  );
}

export default App;
